"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const licenseSchema = new mongoose_1.Schema({
    licenseKey: {
        type: String,
        required: true,
        unique: true,
    },
    infisicalIdentity: String,
    userId: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        required: true,
    },
    teamId: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
        required: false,
    },
    subscriptionId: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Subscription",
        required: true,
    },
    status: {
        type: String,
        enum: Object.values(enum_1.LicenseStatus),
        default: enum_1.LicenseStatus.ACTIVE,
    },
    tag: String,
    devices: [
        {
            deviceId: {
                type: String,
                required: true,
            },
            hostname: String,
            lastSeen: {
                type: Date,
                default: Date.now,
            },
            isActive: {
                type: Boolean,
                default: true,
            },
        },
    ],
    maxDevices: {
        type: Number,
        required: true,
        default: 1,
    },
}, { timestamps: true });
// licenseSchema.index({ userId: 1, status: 1 });
// licenseSchema.index({ licenseKey: 1 });
licenseSchema.methods.cleanupInactiveDevices = function () {
    return __awaiter(this, void 0, void 0, function* () {
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        this.devices = this.devices.filter((device) => device.lastSeen > thirtyDaysAgo || device.isActive);
        yield this.save();
    });
};
exports.default = (0, mongoose_1.model)("License", licenseSchema, "licenses");
